import { przezmorzeApi, throwMessageOnBadRequestStatus, throwMessageOnStatuses } from "../../api/api";
import type {
  CreateQuoteRequest,
  CreateQuoteResponse,
  PrepareQuoteRequest,
  Quote as QuoteResponse,
} from "@przezmorze/api-types";

export type { CreateQuoteRequest, CreateQuoteResponse, PrepareQuoteRequest, QuoteResponse };

export async function getQuote(quoteId: string, abortSignal?: AbortSignal): Promise<QuoteResponse> {
  const response = await przezmorzeApi.get<QuoteResponse>(`/quotes/${quoteId}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function createQuote(
  request: CreateQuoteRequest,
  abortSignal?: AbortSignal,
): Promise<CreateQuoteResponse> {
  try {
    const response = await przezmorzeApi.post<CreateQuoteResponse>("/quotes", request, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409], "Invalid request");
  }
}

export async function prepareQuote(
  quoteId: string,
  request: PrepareQuoteRequest,
  abortSignal?: AbortSignal,
): Promise<QuoteResponse> {
  try {
    const response = await przezmorzeApi.put<QuoteResponse>(`/quotes/${quoteId}/prepare`, request, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnBadRequestStatus(error);
  }
}
